import axios from 'axios';
import { setSegmentModelMetadata } from '@foxcorp/delta-web-analytics';
import {
  apiErrorHandler,
  helperGetApiHeaders,
  helperGetApiCategoryUrlRoute,
} from 'helpers/ApiHelper';
import { concatToUrl, isShowcase } from 'helpers/ContentHelper';
import { fetchFooter } from 'components/Footer/FooterActions';

export const FETCH_CHANNEL = 'FETCH_CHANNEL';
export const CLEAR_CHANNEL_PANELS = 'CLEAR_CHANNEL_PANELS';

export const SET_CHANNEL = 'SET_CHANNEL';
export const UPDATE_VISIBLE_ELEMENTS = 'UPDATE_VISIBLE_ELEMENTS';

function setChannel(channelData, panels, showcase, headline, headlineLogo) {
  return {
    type: SET_CHANNEL,
    payload: {
      channelData,
      panels,
      showcase,
      headline,
      headlineLogo,
    },
  };
}

export function clearChannelPanels() {
  return { type: CLEAR_CHANNEL_PANELS };
}

const pageType = 'category';

function fetchChannel(id, accessToken, deviceId) {
  const route = helperGetApiCategoryUrlRoute({ id });
  const request = axios
    .get(concatToUrl(route), helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }))
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_CHANNEL,
    payload: request,
  };
}

export function updateVisibleElements(currentElements) {
  return {
    type: UPDATE_VISIBLE_ELEMENTS,
    payload: currentElements,
  };
}

export function fetchChannels(id, accessToken, deviceId) {
  return dispatch => {
    let panels;
    return dispatch(fetchChannel(id, accessToken, deviceId)).then(result => {
      const data = result?.payload?.data;
      const experimentData = data?.trackingData?.properties?.abtest ?? null;
      const experimentKey = experimentData?.experimentKey ?? null;
      const variationKey = experimentData?.variationKey ?? null;

      setSegmentModelMetadata(result?.payload?.data?.trackingData?.properties?.modelMetaData ?? {});
      panels = data?.panels;
      panels = {
        ...panels,
        seo: data?.SEO,
        categoryType: data?.categoryType,
      };
      if (experimentKey && variationKey) panels.experimentData = `${experimentKey}:${variationKey}`;
      const screenPanels = panels?.member;
      if (!screenPanels) {
        return Promise.resolve();
      }
      return Promise.resolve()
        .then(() => {
          const firstItem = panels?.member[0];
          const isTypeShowcase = isShowcase(firstItem);
          let showcase;
          let newPanels;
          if (isTypeShowcase) {
            showcase = panels?.member[0];
            const members = panels?.member;
            newPanels = {
              ...panels,
              member: members?.slice(1),
              totalItems: (panels.totalItems -= 1),
            };
          } else {
            newPanels = { ...panels };
          }
          const channelData = data;
          const headline = data?.headline;
          const headlineLogo = data?.images?.[`logo-tab-alt`]?.raw ?? data?.images?.logo?.raw ?? '';
          return dispatch(setChannel(channelData, newPanels, showcase, headline, headlineLogo));
        })
        .then(() => dispatch(fetchFooter()));
    });
  };
}
